import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { ClientDetailsData } from "../services/clients.service";

export interface ClientDetailState {
  selectedClientDetails: ClientDetailsData | null;
  selectedClientId: string | number | null;
}

const initialState: ClientDetailState = {
  selectedClientDetails: null,
  selectedClientId: null,
};

const clientDetailSlice = createSlice({
  name: "clientDetail",
  initialState,
  reducers: {
    setSelectedClientDetails: (state, action: PayloadAction<ClientDetailsData | null>) => {
      const payload = action.payload;
      state.selectedClientDetails = payload;
      state.selectedClientId =
        payload !== null && payload.client_id !== null ? payload.client_id : null;
    },
    clearClientDetail: () => initialState,
  },
});

export const { setSelectedClientDetails, clearClientDetail } = clientDetailSlice.actions;

export default clientDetailSlice.reducer;
